<script>
import { layoutComputed } from "@/state/helpers";
import Layout from "../../layouts/main.vue";
import { menuItems } from "../data";
import Heading from "../../layouts/heading.vue";
import appConfig from "@/app.config";
import api from "../../../api";

export default {
  page: {
    title: "Settings",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
  },
  data() {
    return {
      categories: [
        {
          name: "Practices",
          additionalProp1: {
            icon: "practices_blue.svg",
            link: "/practices",
          },
        },
        {
          name: "PCN",
          additionalProp1: {
            icon: "practices_blue.svg",
            link: "/pcns",
          },
        },
        {
          name: "Users",
          additionalProp1: {
            icon: "users.svg",
            link: "/users",
          },
        },
        {
          name: "Permissions",
          additionalProp1: {
            icon: "permissions.svg",
            link: "/admin/roles",
          },
        },
        {
          name: "Mail",
          additionalProp1: {
            icon: "mail.svg",
            link: "/admin/mail",
          },
        },
        {
          name: "Audit",
          additionalProp1: {
            icon: "users.svg",
            link: "/audit",
          },
        },
      ],
      page: {
        title: "Settings",
        lastUpdated: false,
        addNewBtn: false,
        addNewModalTitle: "Create New Page",
        formData: {},
        schema: {
          name: {
            type: "text",
            label: "Name",
            placeholder: "Enter Name",
            required: true,
            info: false,
            character_count: 50,
          },
          icon: {
            type: "text",
            label: "Icon",
            placeholder: "Enter Icon Class",
            required: false,
            info: false,
            character_count: 0,
          },
          link: {
            type: "text",
            label: "link",
            placeholder: "Enter Link",
            required: true,
            info: false,
            character_count: 0,
          },
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
      menuItems: menuItems,
      productNewsList: [],
      categoriesList: [],
    };
  },
  computed: {
    ...layoutComputed,
    prdouctNewsCategory() {
      return (
        this.categoriesList.find((cat) => cat.name == "Product News") || null
      );
    },
  },
  methods: {
    async init() {
      await this.getProductPages();
      await this.updateCategories();
    },
    updateCategories() {
      if (
        this.prdouctNewsCategory !== null &&
        this.categories.findIndex((rt) => rt.name === "Product News") === -1
      ) {
        this.categories.push({
          name: "Product News",
          additionalProp1: {
            icon: "users.svg",
            link: "/productnews",
          },
        });
        this.$store.commit("updateCurrentCategory", this.prdouctNewsCategory);
      }
    },
    async getProductPages() {
      if (this.prdouctNewsCategory?.id) {
        let { data } = await api.get(
          "/api/categories/" + this.prdouctNewsCategory.id + "/pages"
        );
        console.log("response", data);
        this.productNewsList = data;
      }
    },
    async getCategories() {
      console.log("currentPractice", this.currentPractice);
      if (
        this.currentPractice &&
        Object.prototype.hasOwnProperty.call(this.currentPractice, "pcnId")
      ) {
        console.log("getCategories");
        await api
          .get(`/api/pcns/${this.currentPcn.id}/practice-data`)
          .then((response) => {
            api
              .get(`/api/practice-data/${response.data.id}/cms`)
              .then((response2) => {
                api
                  .get(`/api/cms/${response2.data.id}/categories`)
                  .then((response3) => {
                    this.categoriesList = response3.data;
                    this.init();
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.categoriesList = [];
      }
    },
  },
  watch: {
    currentPcn() {
      this.getCategories();
    },
  },
  async mounted() {
    await this.getCategories();
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>

    <div class="row mt-4" style="letter-spacing: 0.02em">
      <div
        class="col-md-2"
        v-for="item in categories"
        v-bind:key="item.id"
        :to="item.link"
      >
        <template v-if="item.name === 'Product News'">
          <router-link
            :to="{
              name: item.name,
              params: {
                category: item,
                categoryObject: prdouctNewsCategory,
                cmsId: $route.params.cmsId,
                catId: prdouctNewsCategory.id,
              },
            }"
            :category="item"
            class="text-dark"
          >
            <div class="card align-items-center">
              <div class="card-body p-0">
                <div class="text-primary font-size-50">
                  <span v-if="item.additionalProp1.icon">
                    <img
                      v-if="item.additionalProp1.icon.endsWith('.svg')"
                      :src="
                        require(`@/assets/images/${item.additionalProp1.icon}`)
                      "
                    />
                    <i v-else :class="item.additionalProp1.icon"></i>
                  </span>
                </div>
              </div>
              <div class="card-body p-0 pb-3 pt-2 text-center">
                <p class="mx-auto text-uppercase m-0 font-weight-medium">
                  {{ item.name }}
                </p>
              </div>
            </div>
          </router-link>
        </template>
        <template v-else>
          <router-link
            :to="{
              name: item.name,
              params: { category: item, cmsId: $route.params.cmsId },
            }"
            :category="item"
            class="text-dark"
          >
            <div class="card align-items-center">
              <div class="card-body p-0">
                <div class="text-primary font-size-50">
                  <span v-if="item.additionalProp1.icon">
                    <img
                      v-if="item.additionalProp1.icon.endsWith('.svg')"
                      :src="
                        require(`@/assets/images/${item.additionalProp1.icon}`)
                      "
                    />
                    <i v-else :class="item.additionalProp1.icon"></i>
                  </span>
                </div>
              </div>
              <div class="card-body p-0 pb-3 pt-2 text-center">
                <p class="mx-auto text-uppercase m-0 font-weight-medium">
                  {{ item.name }}
                </p>
              </div>
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </Layout>
</template>
